import e, { useRef as i, useEffect as d } from "react";
import t from "./index129.mjs";
import u from "classnames";
import E from "./index127.mjs";
const N = ({ actions: c }) => /* @__PURE__ */ e.createElement("div", { className: t.actions }, c.map((a, l) => /* @__PURE__ */ e.createElement(
  "button",
  {
    "data-testid": a.dataTestId || `alert-action-${l}`,
    className: u(t.action_button, a.className, {
      [t.button_secondary]: a.secondary
    }),
    type: "button",
    key: a.label,
    onClick: () => {
      a.onClick && a.onClick();
    }
  },
  a.label
))), _ = ({
  title: c,
  subTitle: a,
  icon: l,
  actions: o,
  onClose: s,
  children: r
}) => {
  const m = i(null);
  return d(() => {
    var n;
    (n = m.current) == null || n.scrollIntoView({ behavior: "smooth" });
  }, []), /* @__PURE__ */ e.createElement(
    "div",
    {
      "data-testid": "modal-overlay",
      className: t.modal_overlay,
      onClick: s
    },
    /* @__PURE__ */ e.createElement(
      "div",
      {
        "data-testid": "modal-content",
        className: t.content,
        ref: m,
        onClick: (n) => n.stopPropagation()
      },
      /* @__PURE__ */ e.createElement("div", { className: t.header }, /* @__PURE__ */ e.createElement("div", { className: t.title_container }, l ? /* @__PURE__ */ e.createElement("div", { "data-testid": "modal-icon", className: t.icon_container }, /* @__PURE__ */ e.createElement(l, null)) : null, /* @__PURE__ */ e.createElement("h2", { className: t.title }, c)), /* @__PURE__ */ e.createElement(
        "button",
        {
          type: "button",
          className: t.close_button,
          onClick: s
        },
        /* @__PURE__ */ e.createElement(E, null)
      )),
      a ? /* @__PURE__ */ e.createElement("p", { className: t.description }, a) : null,
      r ? /* @__PURE__ */ e.createElement("div", { className: t.children_container }, r) : null,
      o ? /* @__PURE__ */ e.createElement(N, { actions: o }) : null
    )
  );
};
export {
  _ as Modal
};
